import React from "react";

const BackgroundImage = (props) => {
	return <div className="background-image">
		<div className="overlay"/>
	</div>;
}
	
export default BackgroundImage;
